var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-content" },
    [
      _vm.userEditId
        ? _c("SideBarModal", {
            attrs: {
              user: { id: _vm.userEditId },
              roles: _vm.roles,
              updateRecord: _vm.updateUserList,
              onModalClose: () => (this.userEditId = null),
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.loading
        ? [
            _c("pulse-loader", {
              staticClass: "text-center",
              attrs: { loading: true, color: _vm.loadingColor },
            }),
          ]
        : [
            _vm._l(_vm.$AllDivisions, function (div) {
              return _c("div", { staticClass: "card mb-1" }, [
                _c("div", { staticClass: "card-header bg-info" }, [
                  _c("h6", [
                    _c(
                      "strong",
                      _vm._l(div.cities, function (c, i) {
                        return _c("span", [
                          _vm._v(
                            _vm._s((c.city && c.city.name) || "Почта") +
                              _vm._s(
                                i === 0 && div.cities.length > 1 ? ", " : ""
                              )
                          ),
                        ])
                      }),
                      0
                    ),
                    _vm._v("\n          (ID:" + _vm._s(div.id) + ")\n        "),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-body p-3" }, [
                  _c(
                    "table",
                    {
                      staticClass:
                        "table table-striped table-sm table-hover mb-0",
                    },
                    [
                      _c(
                        "tbody",
                        [
                          _vm.users[div.id] && _vm.users[div.id].chief
                            ? [
                                _vm._m(0, true),
                                _vm._v(" "),
                                _vm._l(_vm.users[div.id].chief, function (r) {
                                  return _c("tr", [
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(r.name) +
                                          " (" +
                                          _vm._s(r.login) +
                                          ")"
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      [
                                        _vm.userDetails[r.id].tablet_imei
                                          ? [
                                              !_vm.popover[r.id].imei
                                                ? _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "btn btn-xs btn-outline-info",
                                                      attrs: { type: "button" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          _vm.popover[
                                                            r.id
                                                          ].imei = true
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            _vm.userDetails[
                                                              r.id
                                                            ].tablet_imei
                                                              .details
                                                          ) +
                                                          "\n                  "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.popover[r.id].imei
                                                ? _c(
                                                    "v-popover",
                                                    {
                                                      attrs: {
                                                        popoverClass:
                                                          "popover_white",
                                                        "auto-hide": true,
                                                        open:
                                                          _vm.popover[r.id] &&
                                                          _vm.popover[r.id]
                                                            .imei,
                                                      },
                                                      on: {
                                                        hide: function (
                                                          $event
                                                        ) {
                                                          return _vm.destroyPopover(
                                                            r.id,
                                                            "imei"
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "btn btn-xs btn-outline-info",
                                                          attrs: {
                                                            type: "button",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                      " +
                                                              _vm._s(
                                                                _vm.userDetails[
                                                                  r.id
                                                                ].tablet_imei
                                                                  .details
                                                              ) +
                                                              "\n                    "
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "template",
                                                        { slot: "popover" },
                                                        [
                                                          _c("div", [
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "mb-1",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Редактирование устройства"
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              [
                                                                _c(
                                                                  "LoadingButton",
                                                                  {
                                                                    attrs: {
                                                                      title:
                                                                        "Отвязать IMEI",
                                                                      className:
                                                                        "btn btn-warning btn-xs mb-1",
                                                                      onClick:
                                                                        () =>
                                                                          _vm.updateUser(
                                                                            r.id,
                                                                            "imei",
                                                                            "disable_imei"
                                                                          ),
                                                                      loading:
                                                                        _vm.btnLoading,
                                                                      color:
                                                                        "white",
                                                                    },
                                                                  }
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "LoadingButton",
                                                                  {
                                                                    attrs: {
                                                                      title:
                                                                        "Отозвать сертификат",
                                                                      className:
                                                                        "btn btn-warning btn-xs",
                                                                      onClick:
                                                                        () =>
                                                                          _vm.updateUser(
                                                                            r.id,
                                                                            "imei",
                                                                            "disable_tablet_certificate"
                                                                          ),
                                                                      loading:
                                                                        _vm.btnLoading,
                                                                      color:
                                                                        "white",
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ]),
                                                        ]
                                                      ),
                                                    ],
                                                    2
                                                  )
                                                : _vm._e(),
                                            ]
                                          : _vm._e(),
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c("td", [
                                      _c("div", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.userInfoMessage(r.id)
                                          ),
                                        },
                                      }),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      {
                                        staticClass: "text-right",
                                        attrs: { colspan: "20" },
                                      },
                                      [
                                        _c("div", [
                                          _vm.users[div.id].runners &&
                                          _vm.users[div.id].runners.length
                                            ? _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn btn-default btn-xs mr-1",
                                                  on: {
                                                    click: function ($event) {
                                                      _vm.showRunners[div.id] =
                                                        !_vm.showRunners[div.id]
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    Курьеры в группе (" +
                                                      _vm._s(
                                                        _vm.users[div.id]
                                                          .runners.length
                                                      ) +
                                                      ")\n                  "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-xs btn-info mr-1",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.openUserInModal(
                                                    r.id
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "icon-fa icon-fa-eye",
                                              }),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-info btn-xs hidden",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.mixinGoToRouter(
                                                    "settingsAccessUsersEdit",
                                                    {
                                                      id: r.id,
                                                    }
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "icon-fa icon-fa-edit",
                                              }),
                                            ]
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ])
                                }),
                              ]
                            : [_vm._m(1, true)],
                          _vm._v(" "),
                          _vm.users[div.id] &&
                          _vm.users[div.id].runners &&
                          _vm.showRunners[div.id]
                            ? [
                                _vm._m(2, true),
                                _vm._v(" "),
                                _vm._l(_vm.users[div.id].runners, function (r) {
                                  return _c("tr", [
                                    _c("td", [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(r.name) +
                                          " (" +
                                          _vm._s(r.login) +
                                          ")\n              "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      [
                                        _vm.userDetails[r.id].tablet_imei
                                          ? [
                                              !_vm.popover[r.id].imei
                                                ? _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "btn btn-xs btn-outline-info",
                                                      attrs: { type: "button" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          _vm.popover[
                                                            r.id
                                                          ].imei = true
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            _vm.userDetails[
                                                              r.id
                                                            ].tablet_imei
                                                              .details
                                                          ) +
                                                          "\n                  "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.popover[r.id].imei
                                                ? _c(
                                                    "v-popover",
                                                    {
                                                      attrs: {
                                                        popoverClass:
                                                          "popover_white",
                                                        "auto-hide": true,
                                                        open:
                                                          _vm.popover[r.id] &&
                                                          _vm.popover[r.id]
                                                            .imei,
                                                      },
                                                      on: {
                                                        hide: function (
                                                          $event
                                                        ) {
                                                          return _vm.destroyPopover(
                                                            r.id,
                                                            "imei"
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "btn btn-xs btn-outline-info",
                                                          attrs: {
                                                            type: "button",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                      " +
                                                              _vm._s(
                                                                _vm.userDetails[
                                                                  r.id
                                                                ].tablet_imei
                                                                  .details
                                                              ) +
                                                              "\n                    "
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "template",
                                                        { slot: "popover" },
                                                        [
                                                          _c("div", [
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "mb-1",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Редактирование устройства"
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              [
                                                                _c(
                                                                  "LoadingButton",
                                                                  {
                                                                    attrs: {
                                                                      title:
                                                                        "Отвязать IMEI",
                                                                      className:
                                                                        "btn btn-warning btn-xs mb-1",
                                                                      onClick:
                                                                        () =>
                                                                          _vm.updateUser(
                                                                            r.id,
                                                                            "imei",
                                                                            "disable_imei"
                                                                          ),
                                                                      loading:
                                                                        _vm.btnLoading,
                                                                      color:
                                                                        "white",
                                                                    },
                                                                  }
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "LoadingButton",
                                                                  {
                                                                    attrs: {
                                                                      title:
                                                                        "Отозвать сертификат",
                                                                      className:
                                                                        "btn btn-warning btn-xs",
                                                                      onClick:
                                                                        () =>
                                                                          _vm.updateUser(
                                                                            r.id,
                                                                            "imei",
                                                                            "disable_tablet_certificate"
                                                                          ),
                                                                      loading:
                                                                        _vm.btnLoading,
                                                                      color:
                                                                        "white",
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ]),
                                                        ]
                                                      ),
                                                    ],
                                                    2
                                                  )
                                                : _vm._e(),
                                            ]
                                          : _vm._e(),
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c("td", [
                                      _c("div", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.userInfoMessage(r.id)
                                          ),
                                        },
                                      }),
                                    ]),
                                    _vm._v(" "),
                                    _c("td", { staticClass: "text-right" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex justify-content-end",
                                        },
                                        [
                                          !_vm.popover[r.id].disable &&
                                          (!r.orders || !r.orders.length)
                                            ? _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn btn-xs btn-outline-warning mr-1",
                                                  attrs: { type: "button" },
                                                  on: {
                                                    click: function ($event) {
                                                      _vm.popover[
                                                        r.id
                                                      ].disable = true
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    В архив\n                  "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.popover[r.id].disable
                                            ? _c(
                                                "v-popover",
                                                {
                                                  attrs: {
                                                    popoverClass:
                                                      "popover_white",
                                                    "auto-hide": true,
                                                    open:
                                                      _vm.popover[r.id] &&
                                                      _vm.popover[r.id].disable,
                                                  },
                                                  on: {
                                                    hide: function ($event) {
                                                      return _vm.destroyPopover(
                                                        r.id,
                                                        "disable"
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "btn btn-xs btn-outline-warning mr-1",
                                                      attrs: { type: "button" },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      В архив\n                    "
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "template",
                                                    { slot: "popover" },
                                                    [
                                                      _c("div", [
                                                        _c(
                                                          "p",
                                                          {
                                                            staticClass: "mb-1",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Отправить курьера"
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "p",
                                                          {
                                                            staticClass: "mb-1",
                                                          },
                                                          [
                                                            _c("strong", [
                                                              _vm._v(
                                                                _vm._s(r.name)
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "p",
                                                          {
                                                            staticClass: "mb-1",
                                                          },
                                                          [_vm._v("в архив?")]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          [
                                                            _c(
                                                              "LoadingButton",
                                                              {
                                                                attrs: {
                                                                  title:
                                                                    "в архив",
                                                                  className:
                                                                    "btn btn-warning btn-xs",
                                                                  onClick: () =>
                                                                    _vm.updateUser(
                                                                      r.id,
                                                                      "disable"
                                                                    ),
                                                                  loading:
                                                                    _vm.btnLoading,
                                                                  color:
                                                                    "white",
                                                                },
                                                              }
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                ],
                                                2
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-xs btn-info mr-1",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.openUserInModal(
                                                    r.id
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "icon-fa icon-fa-eye",
                                              }),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-info btn-xs hidden",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.mixinGoToRouter(
                                                    "settingsAccessUsersEdit",
                                                    {
                                                      id: _vm.u.id,
                                                    }
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "icon-fa icon-fa-edit",
                                              }),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]),
                                  ])
                                }),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                    ]
                  ),
                ]),
              ])
            }),
            _vm._v(" "),
            _vm.unlinkedUsers && _vm.unlinkedUsers.length > 0
              ? _c("div", { staticClass: "card" }, [
                  _vm._m(3),
                  _vm._v(" "),
                  _c("div", { staticClass: "card-body" }, [
                    _c(
                      "table",
                      {
                        staticClass: "table table-hover table-sm table-striped",
                      },
                      [
                        _c(
                          "tbody",
                          _vm._l(_vm.unlinkedUsers, function (u, i) {
                            return _c("tr", [
                              _c("td", [_vm._v(_vm._s(i + 1))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(u.name))]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-right" }, [
                                _c("div", {}, [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-xs btn-info mr-1",
                                      on: {
                                        click: function ($event) {
                                          return _vm.openUserInModal(u.id)
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "icon-fa icon-fa-eye",
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-info btn-xs hidden",
                                      on: {
                                        click: function ($event) {
                                          return _vm.mixinGoToRouter(
                                            "settingsAccessUsersEdit",
                                            {
                                              id: u.id,
                                            }
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "icon-fa icon-fa-edit",
                                      }),
                                    ]
                                  ),
                                ]),
                              ]),
                            ])
                          }),
                          0
                        ),
                      ]
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.inactiveUsers && _vm.inactiveUsers.length > 0
              ? _c("div", { staticClass: "card" }, [
                  _vm._m(4),
                  _vm._v(" "),
                  _c("div", { staticClass: "card-body" }, [
                    _c(
                      "table",
                      {
                        staticClass: "table table-hover table-sm table-striped",
                      },
                      [
                        _c(
                          "tbody",
                          _vm._l(_vm.inactiveUsers, function (u, i) {
                            return _c("tr", [
                              _c("td", [_vm._v(_vm._s(i + 1))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(u.name))]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-right" }, [
                                _c("div", {}, [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-xs btn-info mr-1",
                                      on: {
                                        click: function ($event) {
                                          return _vm.openUserInModal(u.id)
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "icon-fa icon-fa-eye",
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-info btn-xs hidden",
                                      on: {
                                        click: function ($event) {
                                          return _vm.mixinGoToRouter(
                                            "settingsAccessUsersEdit",
                                            {
                                              id: u.id,
                                            }
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "icon-fa icon-fa-edit",
                                      }),
                                    ]
                                  ),
                                ]),
                              ]),
                            ])
                          }),
                          0
                        ),
                      ]
                    ),
                  ]),
                ])
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", { staticClass: "label" }, [
      _c("td", { attrs: { width: "380px" } }, [_vm._v("Главные курьеры:")]),
      _vm._v(" "),
      _c("td", { attrs: { width: "150px" } }),
      _vm._v(" "),
      _c("td", { attrs: { width: "30%" } }),
      _vm._v(" "),
      _c("td", { attrs: { colspan: "20" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", { staticClass: "warning" }, [
      _c("td", { attrs: { colspan: "20" } }, [
        _vm._v("Главный курьер не назначен!"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", { staticClass: "label" }, [
      _c("td", { attrs: { width: "380px" } }, [_vm._v("Курьеры")]),
      _vm._v(" "),
      _c("td", { attrs: { width: "150px" } }, [_vm._v("IMEI")]),
      _vm._v(" "),
      _c("td", { attrs: { width: "30%" } }, [_vm._v("Info")]),
      _vm._v(" "),
      _c("td"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h6", [_vm._v("Курьеры без дивизиона")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header bg-warning" }, [
      _c("h6", [_vm._v("Не активные курьеры")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }